export default "__VITE_ASSET__a4dbb767__"